import official from './official-ne-gov-app.png';
import NIC from './nic-logo.png'
import {version} from "../../../package.json";

function Footer(){
    const footerInfo = [
        {
            section: {
                title: 'Agency',
                links: [
                    {
                        title: 'Nebraska DMV',
                        href: 'https://dmv.nebraska.gov/'
                    }
                ],
                body: `301 Centennial Mall South<br/>
                PO Box 94789<br/>
                Lincoln, NE 68509-4726`
            },
            section: {
                title: 'Resources',
                links: [
                    {
                        title: 'Nebraska.gov',
                        href: 'www.nebraska.gov'
                    },
                    {
                        title: 'Nebraska State Agencies',
                        href: 'www.nebraska.gov/agencies'
                    },
                    {
                        title: 'Nebraska State Services',
                        href: 'www.nebraska.gov/services'
                    },
                    {
                        title: 'Policies',
                        href: 'www.nebraska.gov/policies'
                    }, 
                    {
                        title: 'Support',
                        href: 'www.nebraska.gov/support'
                    },       
                ]
            }
        }
    ]
    return (
        <footer className="w-full p-4 bg-garfield-header">
            <div className="grid grid-cols-1 md:grid-cols-3 items-start	">
                {/* {footerInfo.map((section, id) => (
                    <div key={id} className="mx-0 mt-5 md:mt-0 md:mx-auto">
                        {section.map((data, dataID) => (
                            <>
                                <h1 key={dataID}>{data.agency}</h1>
                                {data.map((link, linkID) =>(
                                    <a key={linkID} href={link.href}>{link.title}</a>
                                ))}
                                <p>
                                    {data.body}
                                </p>
                            </>
                        ))}
                    </div>
                ))} */}
                <div className="mx-0 mt-5 md:mt-0 md:mx-auto">
                    <h1>Agency</h1>
                    <a className="" href="https://dmv.nebraska.gov/">Nebraska DMV</a>
                    <p>
                        301 Centennial Mall South<br/>
                        PO Box 94789<br/>
                        Lincoln, NE 68509-4726
                    </p>
                </div>
                <div className="mx-0 mt-5 md:mt-0 md:mx-auto">
                    <h1>Resources</h1>
                    <a href="">Nebraska.gov</a><br/>
                    <a href="www.nebraska.gov/agencies">Nebraska State Agencies</a><br/>
                    <a href="www.nebraska.gov/services">Nebraska State Services</a><br/>
                    <a href="www.nebraska.gov/policies">Policies</a><br/>
                    <a href="www.nebraska.gov/support">Support</a><br/>
                </div>
                <div className="mx-0 mt-5 md:mt-0 md:mx-auto">
                    <img src={official} alt="officialnebraskaapp"/><br/>
                    <img src={NIC} className="h-1/4 w-1/4" alt="officialnebraskaapp"/><br/>
                    Built and Maintained by NIC nebraska<br/>
                    © {new Date().getFullYear() } STATE OF NEBRASKA<br/>
                    v{version}
                </div>
            </div>
        </footer>
    )
}

export default Footer;